import React from 'react';
import { I18n } from 'react-redux-i18n';
import {
  CUSTOM_TYPE_INPUT,
  VALID_CASE,
} from '../../../../constants/commondata';

export const ADDON_SERVICE_KEY = {
  name: 'name',
  description: 'description',
  userType: 'userType',
  isRequired: 'isRequired',
  globalAttributeId: 'globalAttributeId',
  feeConfig: 'feeConfig',
  applicationRules: 'applicationRules',
  allowPhotoUpload: 'allowPhotoUpload',
  isApplyTax: 'isApplyTax',
  isItemize: 'isItemize',
  fleetCommission: 'fleetCommission',
};
export const FLEET_COMMISSION_TYPE_VALUE = {
  percentage: 'percentage',
  amount: 'amount',
};

export const RULE_SERVICE_TYPE = {
  pointToPoint: 'pointToPoint',
  fromAirport: 'fromAirport',
  toAirport: 'toAirport',
  hourly: 'hourly',
  // roundTrip: 'roundTrip',
};

export const ADD_ON_USER_TYPE_VALUE = {
  customer: 'customer',
  driver: 'driver',
  // fleet: 'fleet',
};

export const GLOBAL_ATTRIBUTE_VALUE = {
  tollFee: 'tollFee',
  parkingFee: 'parkingFee',
  gasFee: 'gasFee',
  otherFees: 'otherFees',
  airportFee: 'airportFee',
  meetDriverFee: 'meetDriverFee',
  techFee: 'techFee',
  heavyTraffic: 'heavyTraffic',
};

export const ADD_ON_FEE_TYPE_VALUE = {
  amount: 'amount',
  percentageSubtotal: 'percentageSubtotal',
  percentageTotal: 'percentageTotal',
  custom: 'custom',
};

export const ADD_ON_UNIT_VALUE = {
  none: 'none',
  perDay: 'perDay',
  eachTime: 'eachTime',
  each: 'each',
  perPerson: 'perPerson',
};

export const ADD_ON_BOOKING_CHANNEL_VALUE = {
  API: 'API',
  CC: 'CC',
  passenger: 'passenger',
  PWA: 'PWA',
  partner: 'partner',
  CarHailing: 'Car-hailing',
  streetSharing: 'streetSharing',
};

export const TRIP_CONTEXT_VALUE = {
  departure: 'departure',
  arrival: 'arrival',
};

export const FORM_FIELDS_ADDON_SERVICE_INFO = {
  description: {
    type: 'textarea',
    titleI18n: 'addonService.Description',
    key: ADDON_SERVICE_KEY.description,
    placeholderI18n: 'addonService.desPlaceholder',
  },
  userType: {
    type: 'select',
    titleI18n: 'addonService.User_Type',
    textI18n: 'addonService.Who_pays_for_this_add_on',
    key: ADDON_SERVICE_KEY.userType,
    optionI18n: (value) => `addonService.${value}`,
    validCases: [VALID_CASE.required],
  },
  checkboxGroup: {
    key: 'checkboxGroup',
    group: [
      {
        key: ADDON_SERVICE_KEY.isRequired,
        titleI18n: 'addonService.Required',
        type: CUSTOM_TYPE_INPUT.CC_CHECKBOX,
      },
      {
        key: 'feeConfig.isApplyTax',
        titleI18n: 'addonService.Apply_Tax',
        type: CUSTOM_TYPE_INPUT.CC_CHECKBOX,
      },
      // {
      //   key: 'feeConfig.isItemize',
      //   type: CUSTOM_TYPE_INPUT.CC_CHECKBOX,
      //   titleI18n: 'addonService.Itemize',
      //   toolTipI18n: {
      //     text: 'addonService.Itemize_Tooltip',
      //     type: 'info',
      //   },
      // },
      {
        key: 'allowNoteInput',
        titleI18n: 'addonService.allowNoteInput',
        type: CUSTOM_TYPE_INPUT.CC_CHECKBOX,
        toolTipI18n: {
          text: 'addonService.allowNoteInputTooltip',
          type: 'info',
        },
      },
      {
        key: 'isDriverCapability',
        titleI18n: 'addonService.isDriverCapability',
        type: CUSTOM_TYPE_INPUT.CC_CHECKBOX,
        toolTipI18n: {
          text: 'addonService.Driver_Capability_Tooltip',
          type: 'info',
        },
      },
      {
        key: 'isVehicleAttribute',
        titleI18n: 'addonService.isVehicleAttribute',
        type: CUSTOM_TYPE_INPUT.CC_CHECKBOX,
        toolTipI18n: {
          text: 'addonService.Vehicle_Attribute_Tooltip',
          type: 'info',
        },
      },
    ]
  },
  globalAttributeId: {
    type: 'select',
    titleI18n: 'addonService.Attribute',
    key: ADDON_SERVICE_KEY.globalAttributeId,
    option: [],
    toolTipI18n: {
      text: 'addonService.Attribute_Tooltip',
      type: 'info',
    },
  },
  feeType: {
    type: 'select',
    titleI18n: 'addonService.Fee_Type',
    key: 'feeConfig.type',
    optionI18n: (value) => `addonService.feeType.${value}`,
    validCases: [VALID_CASE.required],
  },
  feeValue: {
    type: 'number',
    key: 'feeConfig.value',
    validCases: [VALID_CASE.required],
  },
  feeUnit: {
    type: 'select',
    key: 'feeConfig.unit',
    optionI18n: (value) => `addonService.unit.${value}`,
  },
};

export const FORM_FIELDS_ADDON_SERVICE_RULES = {
  vehicleTypes: {
    type: 'select',
    titleI18n: 'addonService.Vehicle_Type',
    key: 'applicationRules.carTypes',
    option: [],
    isMultiSelect: true,
  },
  serviceTypes: {
    type: 'select',
    titleI18n: 'addonService.Service_Type',
    key: 'applicationRules.serviceTypes',
    optionI18n: (value) => `addonService.${value}`,
    isMultiSelect: true,
  },
  meetingZones: {
    type: 'select',
    titleI18n: 'addonService.Meeting_Zone',
    key: 'applicationRules.zones.meetingZones',
    option: [],
    isMultiSelect: true,
  },
  tripContext: {
    key: 'tripContext',
  },
  operationZones: {
    type: 'select',
    titleI18n: 'addonService.Operation_Zone',
    key: 'applicationRules.zones.operationZones',
    option: [],
    isMultiSelect: true,
  },
  restrictedZones: {
    type: 'select',
    titleI18n: 'addonService.Restricted_Zone',
    key: 'applicationRules.zones.restrictedZones',
    option: [], 
    isMultiSelect: true,
  },
  bookingChannels: {
    type: 'select',
    titleI18n: 'addonService.Booking_Channel',
    key: 'applicationRules.bookingChannels',
    optionI18n: (key) => `addonService.ADD_ON_BOOKING_CHANNEL_VALUE.${key}`,
    isMultiSelect: true,
  },
};

export const PATH_ADDON_TEMPLATE = {
  index: '/settings/addon_template',
  detail: (templateId) => `/settings/addon_template/${templateId}`,
};

/**
 * Tự động apply I18n cho field dựa trên các properties có suffix I18n
 * @param {Object} field - Field object cần apply I18n
 * @param {Object} optionValueMap - Map các function để lấy values cho optionI18n
 * @returns {Object} Field đã được apply I18n
 */
export const applyI18nToField = (field, optionValueMap = {}) => {
  if (!field) return field;

  // Tự động apply I18n cho tất cả properties có suffix I18n
  Object.keys(field).forEach((key) => {
    if (key.endsWith('I18n')) {
      const baseKey = key.replace('I18n', '');
      const i18nValue = field[key];

      // Xử lý optionI18n (function)
      if (key === 'optionI18n' && typeof i18nValue === 'function') {
        const getValues = optionValueMap[field.key];
        if (getValues) {
          const values = getValues();
          field.option = values.map((val) => ({
            text: I18n.t(i18nValue(val)),
            value: field.key === 'applicationRules.bookingChannels' 
              ? ADD_ON_BOOKING_CHANNEL_VALUE[val] 
              : val,
          }));
        }
      }
      // Xử lý toolTipI18n (object)
      else if (key === 'toolTipI18n' && typeof i18nValue === 'object') {
        field.toolTip = {
          text: I18n.t(i18nValue.text),
          type: i18nValue.type || 'info',
        };
      }
      // Xử lý các I18n properties thông thường (string)
      else if (typeof i18nValue === 'string') {
        field[baseKey] = I18n.t(i18nValue);
      }
    }
  });

  // Xử lý nested group (checkboxGroup)
  if (field.group && Array.isArray(field.group)) {
    field.group.forEach((item) => applyI18nToField(item, optionValueMap));
  }

  return field;
};

